import ProvinceForm from "./components/province-form";
import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import CityForm from "./components/city-form";
import { ICity } from "src/interface/ICity";
const validationSchema = Yup.object({
  name: Yup.string().required("این فیلد الزامی است"),
});

const initialValues = {
  name: "",
  lat: "",
  long: "",
  provinceId: "",
};

const NewCity = ({
  open,
  setOpen,
  refetch,
  provinceId,
  setRows,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch: () => void;
  provinceId: string;
  setRows: any;
}) => {
  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "cities", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const notifications = useNotifications();

  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      let res;
      values.provinceId = provinceId;
      res = await insertAsync(values);

      if (res.status) {
        notifications.show("شهر جدید با موفقیت ثبت شد!", {
          key: "new-city",
          severity: "success",
          autoHideDuration: 5000,
        });
        const id = res?.data?.id;
        setRows((prevRows: ICity[]) => [...prevRows, { ...values, id: id }]);
        refetch();
        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-city",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
    },
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
        }}
      >
        <DialogTitle>شهر جدید</DialogTitle>
        <DialogContent>
          <CityForm formik={formik} />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewCity;
